import { h } from '@stencil/core';
import cn from 'classnames';
import { EQdsButtonSize, EQdsButtonImportance, getQdsIconLibrary } from '@pes-ui/utils';
import { isEmpty } from 'lodash';
export class PesCtaButton {
  constructor() {
    this.importance = EQdsButtonImportance.EMPHASIZED;
    this.size = EQdsButtonSize.LARGE;
    this.icon = undefined;
    this.extraClass = undefined;
    this.text = undefined;
    this.url = undefined;
    this.target = undefined;
    this.anchor = undefined;
    this.ctaProps = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    const ctaAttributes = {};
    if (!isEmpty(this.url)) {
      ctaAttributes.href = this.url;
      ctaAttributes.target = this.target;
    }
    if (!isEmpty(this.anchor)) {
      ctaAttributes.htmlFor = this.anchor;
    }
    if (!isEmpty(this.icon)) {
      ctaAttributes.iconName = this.icon;
    }
    this.ctaProps = ctaAttributes;
  }
  render() {
    return (h("qds-button", Object.assign({}, this.ctaProps, { block: true, importance: this.importance, padding: "none", size: this.size, text: this.text, class: cn(this.extraClass ? this.extraClass : 'cta-button', {
        'qds-customized-multiline-large-button': this.size === EQdsButtonSize.LARGE,
        'qds-customized-multiline-standard-button': this.size === EQdsButtonSize.STANDARD,
      }), onClick: (e) => this.didClick.emit(e), variant: "hero", iconLibrary: getQdsIconLibrary(this.icon) })));
  }
  static get is() { return "pes-cta-button"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-cta-button.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-cta-button.css"]
    };
  }
  static get properties() {
    return {
      "importance": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "| EQdsButtonImportance.EMPHASIZED\n  | EQdsButtonImportance.STANDARD | EQdsButtonImportance.SUBDUED",
          "resolved": "EQdsButtonImportance.EMPHASIZED | EQdsButtonImportance.STANDARD | EQdsButtonImportance.SUBDUED",
          "references": {
            "EQdsButtonImportance": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "importance",
        "reflect": false,
        "defaultValue": "EQdsButtonImportance.EMPHASIZED"
      },
      "size": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "EQdsButtonSize",
          "resolved": "EQdsButtonSize.LARGE | EQdsButtonSize.SMALL | EQdsButtonSize.STANDARD",
          "references": {
            "EQdsButtonSize": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "size",
        "reflect": false,
        "defaultValue": "EQdsButtonSize.LARGE"
      },
      "icon": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "icon",
        "reflect": false
      },
      "extraClass": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "extra-class",
        "reflect": false
      },
      "text": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "text",
        "reflect": false
      },
      "url": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "url",
        "reflect": false
      },
      "target": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "target",
        "reflect": false
      },
      "anchor": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Anchor for scrolling."
        },
        "attribute": "anchor",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "ctaProps": {}
    };
  }
  static get events() {
    return [{
        "method": "didClick",
        "name": "didClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "MouseEvent",
          "resolved": "MouseEvent",
          "references": {
            "MouseEvent": {
              "location": "global"
            }
          }
        }
      }];
  }
  static get elementRef() { return "el"; }
}
